import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  TemplateRef,
  OnInit,
  Input
} from '@angular/core';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours
} from 'date-fns';
import { Subject } from 'rxjs/Subject';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarDateFormatter,
  DAYS_OF_WEEK,
  // CalendarMonthViewDay
} from 'angular-calendar';
import { CustomDateFormatter } from './custom-date-formatter.provider';
import { MomentModule } from 'angular2-moment';

import { EventService } from '../../services/event.service';
import { ReminderService } from '../../services/reminder.service';
import { MdDialog, MdDialogRef } from '@angular/material';
import { ConfirmDeleteDialogComponent } from '../confirm-delete-dialog/confirm-delete-dialog.component';
import { EventDialogComponent } from '../event-dialog/event-dialog.component';
import { ReminderDialogComponent } from '../reminder-dialog/reminder-dialog.component';
import { ConfigurationService } from '../../services/configuration.service';

import 'core-js/fn/object/entries';

@Component({
  selector: 'app-calendar-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['calendar.component.css'],
  templateUrl: 'calendar.component.html',
  providers: [
  {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter
    }
  ]
})
export class CalendarComponent implements OnInit {
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  @Input() jobId: string;
  @Input() userId: string;
  @Input() headerChange: boolean;

  public view: string = 'month';

  public viewDate: Date = new Date();
  public loading: boolean;
  errorMessage: string;
  username: string;
  public locale: string;

  weekStartsOn: number = DAYS_OF_WEEK.MONDAY;
  weekendDays: number[] = [DAYS_OF_WEEK.FRIDAY, DAYS_OF_WEEK.SATURDAY];

  actionsEvents: CalendarEventAction[] = [
    {
      label: '<i class="fa fa-fw fa-pencil"></i>',
      onClick: ({ event }: { event: any }): void => {
        this.openDialogEvent(event);
      }
    },
    {
      label: '<i class="fa fa-fw fa-times"></i>',
      onClick: ({ event }: { event: any }): void => {
        this.openDialogDelete(event);
      }
    }
  ];

  actionsReminder: CalendarEventAction[] = [
    {
      label: '<i class="fa fa-fw fa-pencil"></i>',
      onClick: ({ event }: { event: any }): void => {
        this.openDialogEvent(event);
      }
    },
    {
      label: '<i class="fa fa-fw fa-times"></i>',
      onClick: ({ event }: { event: any }): void => {
        this.openDialogDelete(event);
      }
    }
  ];

  refresh: Subject<any> = new Subject();

  public events: any[] = [];

  activeDayIsOpen: boolean = true;

  modalData: {
    action: string;
    event: any;
  };

  constructor(
    private modal: NgbModal,
    public eventService: EventService,
    public reminderService: ReminderService,
    public dialog: MdDialog,
    private configurationService: ConfigurationService
  ) { }

  ngOnInit() {
    this.locale = 'es';
    this.refreshConfiguration();

    this.configurationService.configuration$.subscribe(
      response => {
        if (response) {
          this.refreshConfiguration();
        } else {
          this.username = '';
        }
        // this.dialog.open(MessageBoxDialog, {data: {message: "No se pudo conectar con el servidor, Problemas de conexión con internet", success:true, showIcon:true}});
      }
    );

    this.eventService.event.subscribe(() => {
      this.events = [];
      this.getEvents();
      this.getReminders();
      this.update();
    });

    this.events = [];
    this.loading = true;
    this.getEvents();
    this.getReminders();
  }

  refreshConfiguration() {
    if (localStorage.getItem('name')) {
      this.username = localStorage.getItem('name');
    } else {
      this.username = '';
    }
  }

  changeDate(){
    this.getEvents();
    this.getReminders();
  }

  getStartOfWeek(date) {

    // Copy date if provided, or use current date if not
    date = date? new Date(+date) : new Date();
    date.setHours(0,0,0,0);

    // Set date to previous Sunday
    date.setDate(date.getDate() - date.getDay());

    return date;
  }

  getEndOfWeek(date) {
    date = this.getStartOfWeek(date);
    date.setDate(date.getDate() + 6);
    return date;
  }

  getMonthView(){
    this.view = 'month';
    this.changeDate();
  }
  getWeekView(){
    this.view = 'week';
    this.changeDate();
  }
  getDayView(){
    this.view = 'day';
    this.changeDate();
  }
  getEvents() {
    if (this.jobId) {
      let date = this.viewDate;
      let primerDia = this.viewDate;
      let ultimoDia = this.viewDate;
      let startdate = "";
      let enddate = "";
      let mes = date.getMonth() + 1;
      if (this.view === 'day'){
        primerDia = date;
        ultimoDia = date;
        startdate = date.getFullYear() + '-' + mes + '-' + primerDia.getDate();
      }else{
        if (this.view === 'week'){
          primerDia = this.getStartOfWeek(date);
          ultimoDia = this.getEndOfWeek(date);
          let mes1 = primerDia.getMonth() + 1;
          let mes2 = ultimoDia.getMonth() + 1;
          startdate = date.getFullYear() + '-' + mes1 + '-' + primerDia.getDate();
          enddate = date.getFullYear() + '-'  + mes2 +  '-' + ultimoDia.getDate();
        }else{
          primerDia = new Date(date.getFullYear(), date.getMonth(), 1);
          ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
          startdate = date.getFullYear() + '-' + mes + '-' + primerDia.getDate();
          enddate = date.getFullYear() + '-'  + mes +  '-' + ultimoDia.getDate();
        }
      }

      this.events = [];
      this.eventService.getEventList(this.jobId, this.userId, startdate, enddate, 1, 1000).subscribe(
        data => {
          data.events.forEach(element => {
            let title;
            if (element.status === 0) {
              title = element.type.name + ' (' + element.username + ' - No Ha Visto El Evento)';
            }

            if (element.status === -1) {
              title = element.type.name + ' (' + element.username + ' - No Asistirá)';
            }

            if (element.status === 2) {
              title = element.type.name + ' (' + element.username + ' - Asistirá)';
            }

            this.events.push(
              {
                id: element.id,
                type: element.type.id,
                user: element.username,
                start: new Date (element.dateandtime.date),
                title: title,
                details: element.details,
                color: { primary: element.type.color, secondary: '#FFFFFF' },
                actions: this.actionsEvents
              }
            );
          });
          this.update();
          this.loading = false;
        },
        error => {
          this.errorMessage = <any>error;
          this.loading = false;
        }
      );
    }
  }

  getReminders() {
    let date = this.viewDate;
    let primerDia = this.viewDate;
    let ultimoDia = this.viewDate;
    let startdate = "";
    let enddate = "";
    let mes = date.getMonth() + 1;
    if (this.view === 'day'){
      primerDia = date;
      ultimoDia = date;
      startdate = date.getFullYear() + '-' + mes + '-' + primerDia.getDate();
    }else{
      if (this.view === 'week'){
        primerDia = this.getStartOfWeek(date);
        ultimoDia = this.getEndOfWeek(date);
        let mes1 = primerDia.getMonth() + 1;
        let mes2 = ultimoDia.getMonth() + 1;
        startdate = date.getFullYear() + '-' + mes1 + '-' + primerDia.getDate();
        enddate = date.getFullYear() + '-'  + mes2 +  '-' + ultimoDia.getDate();
      }else{
        primerDia = new Date(date.getFullYear(), date.getMonth(), 1);
        ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        startdate = date.getFullYear() + '-' + mes + '-' + primerDia.getDate();
        enddate = date.getFullYear() + '-'  + mes +  '-' + ultimoDia.getDate();
      }
    }


    this.events = [];

    this.reminderService.getReminderList(startdate, enddate).subscribe(
      data => {
        data.events.forEach(element => {
          this.events.push(
            {
              id: element.id,
              type: element.type,
              user: this.username,
              start: new Date (element.dateandtime.date),
              title: element.details,
              details: element.details,
              color: { primary: '#e3bc08', secondary: '#FFFFFF' },
              actions: this.actionsReminder
            }
          );
        });
        this.update();
        this.loading = false;
      },
      error => {
        this.errorMessage = <any>error;
        this.loading = false;
      }
    );
  }

  update() {
    this.refresh.next();
  }

  dayClicked({ date, events }: { date: Date; events: any[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
        this.viewDate = date;
      }
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd
  }: CalendarEventTimesChangedEvent): void {
    event.start = newStart;
    event.end = newEnd;
    this.handleEvent('Dropped or resized', event);
    this.update();
  }

  handleEvent(action: string, event: any): void {
    this.modalData = { event, action };
    this.modal.open(this.modalContent, { size: 'lg' });
  }

  openDialogEvent(event) {
    let dialogRef;
    if (event.type) {
      dialogRef = this.dialog.open(EventDialogComponent);
      dialogRef.componentInstance.editEvent = event;
    } else {
      dialogRef = this.dialog.open(ReminderDialogComponent);
      dialogRef.componentInstance.editReminder = event;
    }
    dialogRef.afterClosed().subscribe(result => {
      this.events = [];
      this.getEvents();
      this.getReminders();
      this.update();
    });
  }

  openDialogDelete(event) {
    let dialogRef;
    if (event.type) {
      dialogRef = this.dialog.open(ConfirmDeleteDialogComponent);
      dialogRef.componentInstance.EventID=event.id;
      dialogRef.componentInstance.deleteEvent=true;
    } else {
      dialogRef = this.dialog.open(ConfirmDeleteDialogComponent);
      dialogRef.componentInstance.ReminderID=event.id;
      dialogRef.componentInstance.deleteReminder=true;
    }
    dialogRef.afterClosed().subscribe(result => {
      this.events = [];
      this.getEvents();
      this.getReminders();
      this.update();
    });
  }

  // beforeMonthViewRender({ body }: { body: CalendarMonthViewDay[] }): void {
  //   body.forEach(cell => {
  //     const groups: any = {};
  //     cell.events.forEach((event: CalendarEvent<{ type: string }>) => {
  //       groups[event.meta.type] = groups[event.meta.type] || [];
  //       groups[event.meta.type].push(event);
  //     });
  //     cell['eventGroups'] = Object.entries(groups);
  //   });
  // }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/view-event/calendar.component.ts